// Helper functions
export const getStatusBadgeColor = (status) => {
  switch (status) {
    case 'active':
    case 'submitted':
    case 'completed':
    case 'converted':
      return 'bg-green-100 text-green-800';
    case 'draft':
    case 'reviewed':
    case 'scheduled':
    case 'contacted':
      return 'bg-yellow-100 text-yellow-800';
    case 'unsubscribed':
    case 'rejected':
    case 'expired':
    case 'cancelled':
    case 'no_response':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatCurrency = (amount) => {
  if (!amount) return 'E0.00';
  return new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
    minimumFractionDigits: 2
  }).format(amount);
};

export const getDisplayName = (item, type) => {
  switch (type) {
    case 'user':
      return item.name || item.username || 'Unnamed User';
    case 'quotation':
      return `Quotation #${item.id}`;
    case 'followup':
      return `Followup #${item.id}`;
    case 'document':
      return item.document_type || 'Document';
    case 'subscriber':
      return item.email;
    default:
      return 'Item';
  }
};

// Get field value with fallback
export const getField = (item, field, fallback = 'N/A') => {
  return item?.[field] || fallback;
};